// extracted by mini-css-extract-plugin
export var alt = "GoNativeSunsetBanner-module--alt--d61f1";
export var bannerContent = "GoNativeSunsetBanner-module--bannerContent--3f4c3";
export var desktopOnly = "GoNativeSunsetBanner-module--desktopOnly--d3beb";
export var fullscreenBanner = "GoNativeSunsetBanner-module--fullscreenBanner--f82b6";
export var fullscreenOuter = "GoNativeSunsetBanner-module--fullscreenOuter--ac567";
export var helloRewardsImage = "GoNativeSunsetBanner-module--helloRewardsImage--4f8d5";
export var main = "GoNativeSunsetBanner-module--main--642fa";
export var mobileOnly = "GoNativeSunsetBanner-module--mobileOnly--9a584";
export var sunsetText = "GoNativeSunsetBanner-module--sunsetText--a87a8";
export var textLeft = "GoNativeSunsetBanner-module--textLeft--c067d";
export var travelPassImage = "GoNativeSunsetBanner-module--travelPassImage--794fc";
export var visuallyHidden = "GoNativeSunsetBanner-module--visuallyHidden--1da0d";